"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRerender = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Returns a callback that when called, rerenders the component.
 */
var useRerender = function () {
    var _a = __read(react_1.default.useState(0), 2), state = _a[0], setState = _a[1];
    var rerender = react_1.default.useCallback(function () { return setState(function (old) { return old + 1; }); }, [setState]);
    // @ts-expect-error: To make it testable.
    rerender.internalState = state;
    return rerender;
};
exports.useRerender = useRerender;
